import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import * as gsap from "gsap";
import {TimelineLite} from "gsap";
import {HorribleHeroesParsedGameData} from "../server/data/HorribleHeroesParsedGameData";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {BitmapText} from "pixi.js";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {HorribleHeroesGameModuleConfig} from "../HorribleHeroesGameModuleConfig";
import {HorribleHeroesReelController} from "../reel/HorribleHeroesReelController";
import {HorribleHeroes} from "../HorribleHeroes";
import {Currency} from "@nolimitcity/slot-game/bin/core/balance/Currency";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";


export class IndiSymWinHighLight implements GameRoundPresentation {
    private _mainTl: TimelineLite | null;

    constructor() {
    }

    abort(isActive: boolean, data: ParsedServerData): gsap.Timeline | null {
        this.removeChildrenFromLayer();
        if (this._mainTl) {
            return this._mainTl;
        }
        return null;
    }

    public getAnimation(data: HorribleHeroesParsedGameData): TimelineLite | null {
        if (!(HorribleHeroes.api.gameClientConfiguration.displayIndividualWinsInGame && data.betWins.length > 0)) {
            return null;
        }
        if (this._mainTl) {
            this._mainTl.progress(1);
            this._mainTl = null;
        }
        this._mainTl = new TimelineLite({
            onComplete: () => {
                this._mainTl = null;
            }
        });
        this._mainTl.to(this, 0.5, {});
        if (this._mainTl) {
            const betWayWinData: IBetWayWinData[] = <IBetWayWinData[]>data.betWins;
            betWayWinData.forEach((betWayWinData, idx) => {
                let winWaysCont: PIXI.Container = this.getWinWaysCont(betWayWinData, idx);
                const durr = this._mainTl?.duration(),
                    subTl = new TimelineLite();
                for (let col: number = 0; col < betWayWinData.reelWinPositions.length; col++) {
                    for (let row: number = 0; row < betWayWinData.reelWinPositions[col].length; row++) {
                        if (betWayWinData.reelWinPositions[col][row]) {
                            const sym = Reels.getSymbol(col, row);
                            if (sym) {
                                subTl.add(this.getSymIndiWinAnim(sym, {
                                    col: col,
                                    row: row
                                }, data, winWaysCont), 0);
                            }
                        }
                    }
                }
                subTl.add(() => {
                    StageManager.getLayer(GameConfig.instance.LAYERS.INDI_SYM_WIN.name).addChild(winWaysCont);
                }, 0);
                subTl.add(() => {
                    this.removeChildrenFromLayer();
                    this._mainTl?.remove(subTl);
                })
                this._mainTl?.add(subTl);
            });
        }
        return this._mainTl;
    }

    private removeChildrenFromLayer(): void {
        const childrens = StageManager.getLayer(GameConfig.instance.LAYERS.INDI_SYM_WIN.name).children;
        childrens.forEach((child) => {
            StageManager.getLayer(GameConfig.instance.LAYERS.INDI_SYM_WIN.name).removeChild(child);
        });
    }

    private getSymIndiWinAnim(sym: StateReelSymbol, symPos: {
        col: number,
        row: number
    }, data: HorribleHeroesParsedGameData, winWaysCont: PIXI.Container | undefined): TimelineLite {
        const tl = new TimelineLite();
        tl.add(HorribleHeroesGameModuleConfig.symbolWinAnimation.playSymbolWinAnimationForIndiSymWin(symPos.col, symPos.row, HorribleHeroesReelController.SYM_SIZE[data.getGameAreaSizeAfter[symPos.col]].height, winWaysCont))
        return tl;
    }

    private getWinWaysCont(data: IBetWayWinData, idx: number): PIXI.Container {
        const cont: PIXI.Container = new PIXI.Container();
        const winNumber = new PIXI.BitmapText(Currency.formatValue(data.multipliedAmount), {
            fontName: "NumbersWinCountUp",
            fontSize: 45,
        });
        while (winNumber.width > GameConfig.instance.SYMBOL_WIDTH-10) {
            --winNumber.fontSize;
        }
        winNumber.pivot.set(winNumber.width/2,winNumber.height/2);

        const waysNumber= new PIXI.BitmapText(data.numberOfCombinations + " ", {
            fontName: "waysFont",
            fontSize: 15,
        });
        waysNumber.pivot.set(waysNumber.width/2,waysNumber.height/2);

        const waysSprite:PIXI.Sprite=new PIXI.Sprite(GameResources.getTextures(data.numberOfCombinations===1?"way":"ways")[0]);
        waysSprite.anchor.set(0, 0.5);
        waysSprite.width=waysSprite.width/2;
        waysSprite.height=waysSprite.height/2;
        waysSprite.position.x=waysNumber.width/2;

        const winWaysCont:PIXI.Container = new PIXI.Container();
        winWaysCont.addChild(waysNumber,waysSprite);
        winWaysCont.position.set(-winNumber.width/3,40);


        cont.addChild(winNumber, winWaysCont);

        cont.position.set(Helper.getSymbolPositions(data.length - 1, data.reelWinPositions[data.length - 1].lastIndexOf(true))[0],
            Helper.getSymbolPositions(data.length - 1, data.reelWinPositions[data.length - 1].lastIndexOf(true))[1]);
        return cont;
    }

}